<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Default</h6>
            </div>
          </header>
          <div class="vs-card--content examplex text-center">
             <vs-pagination :total="40" v-model="currentx"></vs-pagination>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Icons</h6>
            </div>
          </header>
          <div class="vs-card--content examplex">
            <vs-pagination :total="100" v-model="currentx" prev-icon="arrow_back" next-icon="arrow_forward"></vs-pagination>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Limit the amount of links shown</h6>
            </div>
          </header>
          <div class="vs-card--content examplex">
            <vs-pagination :total="30" v-model="currentx" :max="13"></vs-pagination>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Goto</h6>
            </div>
          </header>
          <div class="vs-card--content examplex">
              <vs-pagination :total="20" v-model="currentx" goto ></vs-pagination>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Color</h6>
            </div>
          </header>
          <div class="vs-card--content examplex">
               <input class="input-color" v-model="colorx" type="color">
    <vs-pagination :color="colorx" :total="20" v-model="currentx"></vs-pagination>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({
    currentx: 14,
      colorx: '#f91f43',
  }),
};
</script>
